import { useEffect, useState } from "react";
import className from "classnames";
import { useNavigate, useParams } from "react-router-dom"
import EditExtension from "../EditExtension/EditExtension";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { Globals } from "utils/styleconfig";
import { RiArrowRightSLine, RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import Button from "components/UI/Button/Button";

import { useGetExtensionQuery } from "features/extension/extensionApiSlice";

import List from "components/List/List";
import utilityStyles from "styles/modules/Utility.module.scss";
import ExtensionDevices from "../ExtensionDevices/ExtensionDevices";
import ExtensionDIDs from "../ExtensionDIDs/ExtensionDIDs";
import ExtensionCalls from "../ExtensionCalls/ExtensionCalls";
import Tabs from "components/UI/Tabs/Tabs";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";

const ViewExtension = ({ label }) => {
  const params = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isEditVisible, setEditVisible] = useState(false);

  useEffect(() => {
    dispatch(setNavbarTitle("View Extension"));
  }, [dispatch]);

  const { data: extension, isLoading } = useGetExtensionQuery(params?.id);

  let accountBtnEl = null;

  const toggleEditVisibility = () => {
    setEditVisible(!isEditVisible); // Toggle visibility on button click
  };

  const onViewDevicesBtnHandler = () => {
    navigate(`/extensions/${params.id}/devices`);
  };
  const onAssignDIDBtnHandler = () => {
    navigate(`/extensions/${params.id}/assign_did`);
  };

  const extensionData = [
    { label: "Username", value: extension?.username },
    { label: "User", value: `${extension?.user?.firstname} ${extension?.user.lastname}` },
    { label: "Domain", value: extension?.domain?.name || "" },
    { label: "Account", value: extension?.account?.number },
    // { label: "DIDs", value: extension?.did_id },
    { label: "Caller ID", value: extension?.account_caller_id?.callerid_number },
    { label: "Enabled", value: extension?.enabled ? 'Yes' : 'No' },
    { label: "Created By", value: `${extension?.created_by?.firstname || ""} ${extension?.created_by?.lastname || ""}`.trim() },
  ];

  const tabsData = [
    { key: "devices", label: "Extension Devices", content: <ExtensionDevices label={label} /> },
    { key: "dids", label: "Extension DIDs", content: <ExtensionDIDs label={label} /> },
    { key: "calls", label: "Extension Calls", content: <ExtensionCalls label={label} /> }
  ]

  return (
    <>
      <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
        <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
          <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={extensionData} />

          {isLoading ? (
            <TableSkeleton />
          ) : (
            <div>
              {/* Button to toggle visibility */}
              <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
                {isEditVisible ? (
                  <RiCloseFill color={Globals.colorRed} size={30} />
                ) : (
                  <>
                    <h3>Edit Extension </h3>
                    <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                  </>
                )}
              </Button>
            </div>
          )}
        </div>
        <div>

          {/* <button
            onClick={onAssignDIDBtnHandler}
            className={utilityStyles.btn}
          >
            <h3>Assign DID</h3>
            <RiArrowRightSLine color={Globals.colorDarkBlue} size={16} />
          </button> */}

          {/* <button
            onClick={onViewDevicesBtnHandler}
            className={utilityStyles.btn}
          >
            <h3>View extension devices</h3>
            <RiArrowRightSLine color={Globals.colorDarkBlue} size={16} />
          </button> */}
        </div>
      </div>

      {/* Edit Extension Component Start*/}
      {isEditVisible && (
        <EditExtension label={label} />)
      }

      <Tabs tabs={tabsData} />

      {/* <div className={`${utilityStyles.table__border}`}>
        <ExtensionDevices label={label} />
      </div> */}
    </>
  )
}

export default ViewExtension